<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useViewQuoteStore } from '@/store/ViewQuoteStore';
import { useDialog } from 'primevue/usedialog';
import { useToast } from 'primevue/usetoast';
import Button from 'primevue/button';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import ViewPDFModal from '@/components/modal/ViewPDFModal.vue';

interface Props {
  quoteID: string;
  disabled: boolean;
  isShowBtn?: boolean;
}
const props = defineProps<Props>();

const { t } = useI18n({ useScope: 'global' });
const dialog = useDialog();
const toast = useToast();
const viewQuoteStore = useViewQuoteStore();
const isLoading = ref(false);

const handlePreviewPDF = () => {
  isLoading.value = true;
  viewQuoteStore
    .previewPDF(props.quoteID)
    .then(() => {
      dialog.open(ViewPDFModal, {
        props: {
          header: t('pdf.view_pdf'),
          modal: true,
          style: { width: '90%' }
        }
      });
    })
    .catch(() => {
      toast.add({ severity: 'info', summary: '', detail: t('notification.unexpected_error'), life: 5000 });
    })
    .finally(() => {
      isLoading.value = false;
    });
};
</script>

<template>
  <div>
    <LoadingSpinner v-if="isLoading" />
    <div class="preview-pdf" v-if="isShowBtn">
      <Button class="btn-preview action-button" :disabled="disabled" :label="$t('worksheet.preview_pdf')" icon="pi pi-eye" @click="handlePreviewPDF()" />
    </div>
  </div>
</template>
